import { titles } from './constants'

export const evaluateOnboardingStatuses = ({
  title,
  checkParameters,
  shouldRedirectPMSLogin,
  hasHostedMessagesSet
}) => {
  const {
    campaignRegistry,
    isPmsSyncing,
    tripAdvisor,
    reviewSettings,
    bookingEngine,
    billingInvoiceAdress,
    hostedMessaging,
    phoneNumber,
    logoAndcolors,
    chatbotResponses,
    otaPromo,
    directPromo,
    users,
    enabledCampaigns,
    marketingURL,
    domain
  } = checkParameters

  switch (title) {
    case titles.campaignRegistry:
      if (campaignRegistry === 'NotStarted') {
        return {
          status: 'Set up'
        }
      } else if (campaignRegistry === 'InProgress') {
        return {
          status: 'Pending'
        }
      } else if (campaignRegistry === 'Completed') {
        return {
          status: 'Ok'
        }
      } else {
        return {
          status: 'Set up'
        }
      }
    case titles.pmsSync:
      if (isPmsSyncing === 'NotConnected' && shouldRedirectPMSLogin) {
        return {
          status: 'Set up'
        }
      } else if (isPmsSyncing === 'NotConnected' && !shouldRedirectPMSLogin) {
        return {
          status: 'Pending'
        }
      } else if (isPmsSyncing === 'PartiallyCompleted') {
        return {
          status: 'Pending'
        }
      } else if (isPmsSyncing === 'Completed') {
        return {
          status: 'Ok'
        }
      } else {
        return {
          status: 'Set up'
        }
      }
    case titles.tripAdvisor:
      if (!tripAdvisor) {
        return {
          status: 'Set up'
        }
      } else if (tripAdvisor === 'Pending') {
        return {
          status: 'Pending'
        }
      } else {
        return {
          status: 'Ok'
        }
      }
    case titles.reviewSettings:
      if (!reviewSettings) {
        return {
          status: 'Edit'
        }
      } else {
        return {
          status: 'Ok'
        }
      }
    case titles.bookingEngine:
      if (!bookingEngine) {
        return {
          status: 'Edit'
        }
      } else {
        return {
          status: 'Ok'
        }
      }
    case titles.billingInvoiceAdress: {
      if (!billingInvoiceAdress) {
        return {
          status: 'Edit'
        }
      } else {
        return {
          status: 'Ok'
        }
      }
    }
    case titles.hostedMessaging:
      if (!hostedMessaging && !hasHostedMessagesSet) {
        return {
          status: 'Edit'
        }
      } else if (!hostedMessaging && hasHostedMessagesSet) {
        return {
          status: 'Pending'
        }
      } else {
        return {
          status: 'Ok'
        }
      }
    case titles.phoneNumber:
      if (!phoneNumber) {
        return {
          status: 'Set up'
        }
      } else {
        return {
          status: 'Ok'
        }
      }
    case titles.logoAndcolors:
      if (!logoAndcolors) {
        return {
          status: 'Not set'
        }
      } else {
        return {
          status: 'Ok'
        }
      }
    case titles.chatbotResponses:
      if (!chatbotResponses) {
        return {
          status: 'None',
          value: '-'
        }
      } else {
        return {
          status: 'None',
          value: chatbotResponses
        }
      }
    case titles.otaPromo:
      if (!otaPromo) {
        return {
          status: 'None',
          value: 'no promo'
        }
      } else {
        return {
          status: 'None',
          value: otaPromo
        }
      }
    case titles.directPromo:
      if (!directPromo) {
        return {
          status: 'None',
          value: 'no promo'
        }
      } else {
        return {
          status: 'None',
          value: directPromo
        }
      }
    case titles.users:
      if (!users) {
        return {
          status: 'None',
          value: '-'
        }
      } else {
        return {
          status: 'None',
          value: users
        }
      }
    case titles.enabledCampaigns:
      if (!enabledCampaigns) {
        return {
          status: 'None',
          value: '-'
        }
      } else {
        return {
          status: 'None',
          value: enabledCampaigns
        }
      }
    case titles.domain:
      if (!domain) {
        return {
          status: 'None',
          value: '-'
        }
      } else {
        return {
          status: 'None',
          value: domain
        }
      }
    case titles.marketingURL:
      if (!marketingURL) {
        return {
          status: 'None',
          value: '-'
        }
      } else {
        return {
          status: 'None',
          value: marketingURL
        }
      }
    default:
      return {
        status: 'None'
      }
  }
}
